// Google Analytics 4 utility functions

/**
 * Tracks page views in GA4
 * @param {string} url - The URL of the page
 */
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_ID, {
      page_path: url
    });
  }
};
